<template>
	<div class="mm-page-main">卖出交易</div>
</template>

<script>

	export default {
		data() {
			return {
				
			};
		}
		
	};
</script>
